module.exports = __webpack_public_path__ + "assets/509280389583108b986e152ba0bfd50d.png";